/**
 *
 * Returns the given word pluralised based on given count, using optional suffix if irregular plural is required.
 * @param word {string} - string
 * @param count - number of items to determine if pluralisation is required
 * @param suffix - optional suffix to use for pluralisation
 * @returns plural or singular form of given word
 */
export function pluralise(word: string, count: number, suffix = 's') {
  return count === 1 ? word : `${word}${suffix}`;
}
